/**
 * Imedia
 */

import { breakpoints } from './variables';

// Classes
import './classes/CookieConsent.js';

// Utilities
import './utilities/tinymce';
import './utilities/lightbox';

// Components
import './components/navigation';
import './components/accordion';
import './components/map';
import './components/custom-file';
import './components/registration';
import './components/profile';
import './components/directory';

(function($) {
  var debug_mode = true;

  /**
   * Debug mode
   */
  if (!debug_mode) {
    console = console || {};
    console.log = function() {};
  }

  /**
   * Default theme vars
   */
  if (typeof theme_js_vars === 'undefined') {
    console.error('Cannot load default variables');
  }

  /**
   * Cookie Consent
   */
  const en_description = `We use cookies and similar technologies to improve your browsing experience, monitor the traffic and performance of our site.`;
  const fr_description = `Nous utilisons des témoins et des technologies similaires pour améliorer votre expérience de navigation, contrôler le trafic et les performances de notre site.`;
  const consentConfig = {
    current_lang: 'fr',
    autoclear_cookies: true,
    page_scripts: true,
    hide_from_bots: true,
    cookie_name: 'adgmq_cc_preferences',
    cookie_expiration: 30,
    onChange: (cookie, changed_preferences) => {
      console.log('Changed');
    },
    onAccept: cookie => {
      console.log('Accepted');
    },
    languages: {
      fr: {
        consent_modal: {
          title: 'Nous utilisons des cookies',
          description: `Pour en savoir plus sur notre utilisation des témoins et sur la manière dont nous traitons vos données personnelles, veuillez consulter notre ${theme_js_vars.privacy_policy}.`,
          primary_btn: {
            text: 'Accepter tout',
            role: 'accept_all',
          },
          secondary_btn: {
            text: 'Personnaliser',
            role: 'settings',
          },
        },
        settings_modal: {
          title: 'Préférences témoins',
          save_settings_btn: 'Enregistrer',
          accept_all_btn: 'Accepter tout',
          reject_all_btn: 'Refuser tout',
          close_btn_label: 'Fermer',
          blocks: [
            {
              title: 'Utilisation des témoins',
              description:
                'Vous pouvez gérer vos préférences en matière de témoins en modifiant les paramètres de votre navigateur ou en spécifiant vos choix ci-dessous.',
            },
            {
              title: 'Témoins essentiels (obligatoires)',
              description:
                "Ces témoins permettent d'optimiser votre expérience de navigation et sont essentiels au bon fonctionnement des différentes fonctionnalités.",
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true,
              },
            },
            {
              title: 'Témoins de performance',
              description:
                "Ces témoins permettent d'analyser les comportements de navigation et d'améliorer les performances de notre plateforme.",
              toggle: {
                value: 'analytics',
                enabled: false,
                readonly: false,
              },
            },
          ],
        },
      },
    },
  };

  window.onload = function() {
    const consent = initCookieConsent();
    consent.run(consentConfig);
  };
})(jQuery);

/**
 * Prevent sticky hover touch device
 */

(function(l) {
  var i,
    s = { touchend: function() {} };
  for (i in s) l.addEventListener(i, s);
})(document);

/**
 * Disabled button submit on forum
 */

(function(l) {
  $('.post-answer').submit(function(event) {
    $('.submit-topic').attr('disabled', true);
    $('.submit-answer').attr('disabled', true);
  });
})(document);
